import React from 'react';
import PropTypes from 'prop-types';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

const Modal = props => (
  props.open &&
    <div key={0} className="modal-overlay">
      <div
        className="modal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="rs-modal-title"
        aria-hidden="true"
        data-keyboard="false"
        data-backdrop="static"
      >
        <ReactCSSTransitionGroup transitionName="ease" transitionEnterTimeout={500} transitionLeaveTimeout={300}>
          { props.open &&
          <div key={0} className={`modal-dialog ${props.className}`} role="document">
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" onClick={() => props.onClose()} className="close" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                <h5 className="modal-title">{props.title}</h5>
              </div>
              <div className="modal-body">{props.children}</div>
              {props.showFooter && <div className="modal-footer">
                <button
                  type="button"
                  onClick={() => props.onClose()}
                  aria-label="Close"
                  className="btn btn-secondary btn-cancel"
                  data-dismiss="modal"
                >Close
                </button>
                <button type="button" className="btn btn-primary btn-save">Save changes</button>
              </div>}
            </div>
          </div> }
        </ReactCSSTransitionGroup>
      </div>
    </div>
);

Modal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  showFooter: PropTypes.bool,
  className: PropTypes.string,
};

Modal.defaultProps = {
  open: false,
  onClose: null,
  title: '',
  children: null,
  showFooter: false,
  className: '',
};

export default Modal;



// WEBPACK FOOTER //
// ./src/main/ui/react/product/src/components/Modal/Modal.js